import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CalendarIcon, WindIcon, MapIcon, MessageSquareIcon, BarChart3Icon } from 'lucide-react';
const features = [{
  icon: BookOpenIcon,
  title: 'El Manuscrito Maestro',
  description: '6 capítulos con la ciencia exacta de tu desconexión y la ruta de retorno.'
}, {
  icon: CalendarIcon,
  title: 'Protocolo de 21 Días',
  description: 'Un paso a paso dividido en 3 fases: Silencio, Despertar y Magnetismo.'
}, {
  icon: WindIcon,
  title: 'Técnica de Respiración Velo',
  description: 'El hack de 3 minutos para apagar el estrés biológico al instante.'
}, {
  icon: MapIcon,
  title: 'Mapa de Resonancia Somática',
  description: 'Ejercicios para re-mapear tu piel y eliminar la anestesia.'
}, {
  icon: MessageSquareIcon,
  title: 'Scripts de Invitación Somática',
  description: 'Palabras exactas para comunicar tus necesidades sin culpa ni presión.'
}, {
  icon: BarChart3Icon,
  title: 'Tracker de Progreso PHS',
  description: 'Para monitorear cómo tu cuerpo recupera su sensibilidad día a día.'
}];
export function WhatYouGetSection() {
  return <section className="py-12 px-6 bg-cream" data-id="element-152">
      <div className="max-w-6xl mx-auto" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-154">
          <h2 className="text-3xl md:text-5xl font-playfair text-burgundy-deep mb-4" data-id="element-155">
            Lo que recibes hoy
          </h2>
          <div className="w-24 h-[1px] bg-gold mx-auto" data-id="element-156" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-157">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} className="bg-blush-light/50 p-8 rounded-sm border-l-4 border-gold hover:bg-blush-light transition-colors duration-300 text-center" data-id="element-158">
              <feature.icon className="w-8 h-8 text-gold mb-6 mx-auto" strokeWidth={1.5} data-id="element-159" />
              <h3 className="text-xl font-playfair text-burgundy-deep mb-3" data-id="element-160">
                {feature.title}
              </h3>
              <p className="text-charcoal/70 leading-relaxed" data-id="element-161">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}